import { Job } from "@/models/Job.model";
import { create } from "zustand";

type JobListingState = {
  jobListings: Job[] | null;
  setJobListings: (jobListings: Job[]) => void;
};

export const useJobListingStore = create<JobListingState>(
  (set: (partial: Partial<JobListingState>) => void) => ({
    jobListings: null,
    setJobListings: (newJobListings) =>
      set({
        jobListings: newJobListings,
      }),
  })
);
